import axios from '@/axios'
import { Notify, Loading, QSpinnerTail } from 'quasar'
export default {
  state: {
  },
  actions: {
    postContact ({ commit }, json) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.post('/platform/email', {
        content: json.content,
        from: json.email,
        subject: 'Entre em contato, Multicargo Plataforma - ' + json.name,
        to: 'atendimento@stradasolucoes.com.br',
        type: 'TEXT'
      })
        .then(res => {
          Loading.hide()
          Notify.create({
            message: 'Obrigado, seu contato foi registrado com sucesso, a resposta irá no seu e-mail em breve!',
            position: 'top',
            color: 'positive'
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    postPriceEmail ({ commit }, json) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.post('/platform/email', {
        content: '<h3>Alguém acessou o Multicargo Transportadoras e gostaria de realizar uma cotação com você! Segue a mensagem do usuário: </h3><br>' +
        '<p>' + json.content + '</p>' +
        '<h5>Mensagem enviada a partir de www.multicargo.io</h5>',
        from: json.email,
        subject: 'Temos um cliente para você, Multicargo Plataforma - ' + json.name,
        to: json.transpEmail,
        type: 'HTML'
      })
        .then(res => {
          Loading.hide()
          Notify.create({
            message: 'Sua demanda foi enviada com sucesso, confira a resposta da transportadora mais tarde em seu email, obrigado!',
            position: 'top',
            color: 'positive'
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    sendFreight ({ commit }, json) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.post('/platform/email', {
        content: json.message,
        from: json.email,
        subject: 'Temos um novo frete do Multicargo!',
        to: 'multicargo@multicargo.io',
        type: 'HTML'
      })
        .then(res => {
          Loading.hide()
          Notify.create({
            message: 'Seu frete foi enviado com sucesso, assim que tudo estiver ok lhe responderemos via email, obrigado!',
            position: 'top',
            color: 'positive'
          })
        })
        .catch(err => {
          Loading.hide()
          console.log(err)
        })
    },
    postComplaint ({ commit }, json) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.post('/platform/email', {
        content: json.content,
        from: json.email,
        subject: 'Denúncia, Multicargo Plataforma - ' + json.name,
        to: 'multicargo@multicargo.io',
        type: 'TEXT'
      })
        .then(res => {
          Loading.hide()
          Notify.create({
            message: 'Sua denúncia foi registrada com sucesso e está em analise a partir deste momento, obrigado!',
            position: 'top',
            color: 'positive'
          })
        })
        .catch(err => {
          Loading.hide()
          console.log(err)
        })
    }
  },
  mutations: {
  },
  getters: {
  }
}
